import React, { FunctionComponent } from "react";
import { ComponentProps } from "../components/component-props";
import { Demo } from "../components/demo";

import "./card-demo.scss";

const cardDemo = {
    code: `<Card
    header="Header"
    overflowActions={
        <List>
            <ListItem>
                <ListItemText>Edit</ListItemText>
            </ListItem>
            <ListItem>
                <ListItemText>Delete</ListItemText>
            </ListItem>
        </List>
    }
>
    <CardContentArea>Lorem ipsum dolor sit amet, vel an prima graeci, mei hinc quaerendum ne.</CardContentArea>
    <CardActions>
        <CardActionButtons>
            <TextButton>Click me!</TextButton>
            <TextButton>Click me also!</TextButton>
        </CardActionButtons>
    </CardActions>
</Card>`
};

export const CardDemo: FunctionComponent = () => {
    return (
        <Demo demo={cardDemo}>
            <ComponentProps componentName="Card" />
            <ComponentProps componentName="CardActions" />
            <ComponentProps componentName="CardActionButtons" />
        </Demo>
    );
};

const expandableCardDemo = {
    code: `<ExpandableCard
    header="Header"
    overflowActions={
        <List>
            <ListItem>
                <ListItemText>Edit</ListItemText>
            </ListItem>
            <ListItem>
                <ListItemText>Delete</ListItemText>
            </ListItem>
        </List>
    }
>
    <CardContentArea>Lorem ipsum dolor sit amet, vel an prima graeci, mei hinc quaerendum ne.</CardContentArea>
    <ExpandedCardContentArea expandText="Expand" collapseText="Collapse">This is hidden!</ExpandedCardContentArea>
</ExpandableCard>`
};

export const ExpandableCardDemo: FunctionComponent = () => {
    return (
        <Demo demo={expandableCardDemo}>
            <ComponentProps componentName="ExpandableCard" />
            <ComponentProps componentName="ExpandedCardContentArea" />
        </Demo>
    );
};

